import { SET_LOCAL_TOKENS, UNSET_LOCAL_TOKENS } from '../actions/tokens';

const initialState = {
  access: null,
  refresh: null,
};

const tokensReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOCAL_TOKENS:
      return Object.assign({}, state, {
        ...action.value,
      });
    case UNSET_LOCAL_TOKENS:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};

export default tokensReducer;
